import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable translations has been removed and is no longer part of the public API. 
import { translationChunksConfig, translationsCs } from '@spartacus/assets';
import {
  ConfigModule,
  FeaturesConfig,
  I18nConfig,
  OccConfig,
  provideConfig,
  SiteContextConfig,
} from '@spartacus/core';
import { defaultCmsContentProviders, mediaConfig, OutletPosition, provideOutlet } from '@spartacus/storefront';
import { FooterComponent } from '../spartacus/custom-feature/common/components/footer/footer.component';
import { CustomLayoutConfig } from './layout-config';

@NgModule({
  declarations: [],
  imports: [ConfigModule.withConfig({
    pagination: {
      startLabel: 'Prev',
      previousLabel: 'Prev',
      nextLabel: 'Next',
      rangeCount: 5,
      addNext: true,
      addEnd: false,
      addPrevious: true,
      addStart: false,
    },
  }),],
  providers: [
    provideConfig(CustomLayoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          /* INFO: Don't uncomment and push in the branch for local development uncoment it
         baseUrl: environment.baseUrl,
         */
        },
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {
        currency: ['USD'],
        language: ['en', 'fr_CA', 'es_MX'],
        baseSite: ['NYAB'],
        country: ['USA'],
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translationsCs,
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '6.6',
      },
    }),
    provideOutlet({
    id: 'cx-footer',
    position: OutletPosition.REPLACE,
    component: FooterComponent,
  }),
  ],
})
export class SpartacusConfigurationModule { }
